import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'lib-adv-map-schematic-tabs',
  standalone: false,
  templateUrl: './adv-map-schematic-tabs.component.html',
  styleUrl: './adv-map-schematic-tabs.component.scss'
})
export class AdvMapSchematicTabsComponent implements OnChanges {

  @Input() tabs: { id: number; name: string }[] = [];
  @Output() tabSelected = new EventEmitter<number>();

  activeTab!: number;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['tabs']) {

      const prevLength = changes['tabs'].previousValue?.length ?? 0;
      const currentLength = this.tabs.length;

      if (currentLength > prevLength) {
        const lastTab = this.tabs[currentLength - 1];
        this.activeTab = lastTab.id;
        this.tabSelected.emit(this.activeTab);
      }
    }
  }

  selectTab(id: number) {
    this.activeTab = id;
    this.tabSelected.emit(id);
  }

  closeTab(id: number, event: MouseEvent) {
    event.stopPropagation();

    const index = this.tabs.findIndex(t => t.id === id);
    if (index === -1) return;

    const isActive = this.activeTab === id;

    this.tabs.splice(index, 1);

    // If we closed the active tab → choose another one
    if (isActive) {
      if (this.tabs.length > 0) {
        const newIndex = index > 0 ? index - 1 : 0;
        this.activeTab = this.tabs[newIndex].id;

        // Emit new active tab
        this.tabSelected.emit(this.activeTab);
      } else {
        // No tabs left
        this.activeTab = undefined as any;
      }
    }
  }
}